module.exports = __webpack_public_path__ + "static/media/UGB.1fb745cb.svg";